import type React from 'react';
import { Col, Row, Statistic } from 'antd';
import { Icon } from '@/components/icon';
import { RowGutter } from 'common/spacing';

export const ExampleStatistics: React.VFC = () => (
  <Row gutter={RowGutter.Default}>
    <Col span={8}>
      <Statistic prefix={<Icon iconString="thumbsUp" />} title="Feedback" value={1128} />
    </Col>
    <Col span={8}>
      <Statistic loading title="Forever to lodd" />
    </Col>
    <Col span={8}>
      <Statistic suffix="/ 100" title="Unmerged" value={93} />
    </Col>
  </Row>
);
